export const environment = {
  name: 'acceptance',
  url: 'https://acceptance.bruiloftinjebroekzak.nl',
  apiEndpoint: 'https://acceptance.bruiloftinjebroekzak.nl/api2',
  stripeApiKeyPublishable: 'pk_test_lyyEmaveqDVymvRbM1zUQDzI',
  googleAnalyticsKey: 'G-SFQMSMY0ZK',
  cookieYesKey: '4d0311204afb97697644d8d6'
};
